let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dBE2i")).then(() => parcelRequire('6e98G'));